var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 25,
    viewBox: "0 0 19 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 1.81832H14.3333L13 0.484985H6.33331L4.99998 1.81832H0.333313V4.48499H19M1.66665 21.8183C1.66665 22.5256 1.9476 23.2038 2.44769 23.7039C2.94779 24.204 3.62607 24.485 4.33331 24.485H15C15.7072 24.485 16.3855 24.204 16.8856 23.7039C17.3857 23.2038 17.6666 22.5256 17.6666 21.8183V5.81832H1.66665V21.8183Z",
    fill: "#5B4E4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminBin);
export default __webpack_public_path__ + "static/media/adminBin.ed00c64b3f94e6f76609989169ca291e.svg";
export { ForwardRef as ReactComponent };